import { render, staticRenderFns } from "./WatchNowButton.vue?vue&type=template&id=140e9fe3&scoped=true"
import script from "./WatchNowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchNowButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WatchNowButton.vue?vue&type=style&index=0&id=140e9fe3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e9fe3",
  null
  
)

export default component.exports